<div class="microphone">
  <div
    [ngClass]="{
      'muted-container': microphone.isMuted,
      'unmuted-container': !microphone.isMuted,
    }"
    (click)="onMicrophoneClick($event)">
    @if (microphone.isMuted) {
      <i class="fa fa-microphone-slash" [style.color]="microphone.color"></i>
    } @else {
      @if (microphone.name.toLowerCase() !== 'autocaption') {
        <i class="fa fa-microphone" [style.color]="microphone.color"></i>
      } @else {
        <i class="fa fa-laptop" [style.color]="microphone.color"></i>
      }
    }
  </div>

  <div class="microphone__indicator">
    @if (showText) {
      <span appSpeechBubbleText>
        {{ microphone.name }}
      </span>
    }
  </div>
</div>
